import { render, staticRenderFns } from "./paychannel.vue?vue&type=template&id=2ba65396&"
import script from "./paychannel.vue?vue&type=script&lang=js&"
export * from "./paychannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports